import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Select, Form, Input, Button, Switch, Icon, Alert, Radio, DatePicker } from 'antd'
import { sendNotification, isEmail, KEY_CODE_ENTER } from '../../utils'
import { RequiredField } from '../required-field/RequiredField'
import { getUsers, userExistsByEmail, userExistsReset, createUser, userAddReset } from '../../actions/UsersAction'
import moment from 'moment'
import { PasswordInput } from 'antd-password-input-strength'

const { Option } = Select
const { RangePicker } = DatePicker

export class Create extends Component {

  constructor(props) {
    super(props)
    this.rolSelector = React.createRef()
    this.state = {
      name: '',
      email: '',
      password: '',
      role: 'operator',
      userType: 'Infinite',
      createAndContinue: false,
      isValid: false,
      options: [],
      group: [],
      showUserDates: false,
      initDate: moment().format('YYYY-MM-DD'),
      dueDate: moment().format('YYYY-MM-DD'),
    }
  }

  componentDidMount() {
    this.props.userExistsReset()
    const { group } = this.props
    this.setState({
      options: group.map((r, k) => <Option key={k} value={r.name} uid={r._id}>{r.name}</Option>)
    })
  }

  componentDidUpdate(prevProps) {
    const { userAddStatus, workclient, intl } = this.props
    const { createAndContinue, role } = this.state
    if (prevProps.userAddStatus !== userAddStatus) {
      if (userAddStatus === 'success') {
        sendNotification('success', intl, intl.formatMessage({ id: 'user_created_success' }))
        this.setState({
          name: '',
          email: '',
          password: '',
          role: createAndContinue
            ? role
            : 'operator',
          createAndContinue: false,
          isValid: false
        }, () => {
          this.props.userAddReset()
          this.props.userExistsReset()
        })
        if (!createAndContinue) {
          this.props.handleHideCreateUser()
          this.props.getUsers(workclient, 1, null, true)
        }
      } else if (userAddStatus === 'error') {
        sendNotification('error', intl, intl.formatMessage({ id: 'user_created_failure' }))
      }
    }
  }

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleEmailExists = e => {
    const { workclient } = this.props

    if (e.target.value === '') {
      this.props.userExistsReset()
    } else if (isEmail(e.target.value)) {
      this.props.userExistsByEmail(workclient, e.target.value)
    }
  }

  handleSwitch = isCheck => {
    this.setState({
      password: isCheck ? '' : `Bunkey${new Date().getFullYear()}`
    })
  }

  handleRolOnChange = value => {
    this.setState({
      role: value
    })
  }


  handleCreate = () => {
    const { workclient, userExists, intl } = this.props
    const { name, email, password, role, group, userType, initDate, dueDate } = this.state

    if (name === '' && userExists === 'UserNotFound') {
      sendNotification('error', intl, intl.formatMessage({ id: 'must_enter_name' }))
      return
    } else if (email === '') {
      sendNotification('error', intl, intl.formatMessage({ id: 'empty_email_input' }))
      return
    } else if (!isEmail(email)) {
      sendNotification('error', intl, intl.formatMessage({ id: 'not_valid_email' }))
      return
    } else if (password === '' && userExists === 'UserNotFound') {
      sendNotification('error', intl, intl.formatMessage({ id: 'must_enter_password' }))
      return
    } else if (group.length === 0 && role === 'operator') {
      sendNotification('error', intl, intl.formatMessage({ id: 'must_select_group' }))
      return
    }
    else if (userType === 'Temporary' && !moment(initDate).isSameOrAfter(moment(), 'day')) {
      sendNotification('error', intl, intl.formatMessage({ id: 'invitation_temporary_init_time_error' }))
      return
    }
    else {
      this.props.createUser(name, email, password, role, workclient, group, userType, initDate, dueDate)
    }
  }

  handleCreateSingleUser = e => {
    e.preventDefault()
    this.setState({
      createAndContinue: false
    }, () => this.handleCreate())
  }

  handleCreateNContinue = e => {
    e.preventDefault()
    this.setState({
      createAndContinue: true
    }, () => this.handleCreate())
  }

  handleCancel = () => {
    this.setState({
      name: '',
      email: '',
      password: '',
    }, () => {
      this.props.userExistsReset()
      this.props.userAddReset()
      this.props.handleHideCreateUser()
    })
  }

  handleOnChangeGroup = (item, list) => {
    this.setState({ group: list.map(r => r.props.uid) })
  }

  handleKeyPress = e => {
    if (e.keyCode === KEY_CODE_ENTER) {
      this.rolSelector.current.focus()
      this.handleEmailExists(e)
    }
  }

  handleRadioType = e => {
    if (e.target.value === 'Temporary') {
      this.setState({
        userType: 'Temporary',
        showUserDates: true
      })
    } else {
      this.setState({
        userType: 'Infinite',
        showUserDates: false
      })
    }
  }

  handleOnChangeRangePicker = (date, dateString) => {
    const { isUndefined } = this.state
    const { intl } = this.props

    if (!moment(dateString[0]).isSameOrAfter(moment(), 'day')) {
      sendNotification('error', intl, intl.formatMessage({ id: 'invitation_temporary_init_time_error' }))
    }

    this.setState({
      initDate: dateString[0],
      dueDate: isUndefined
        ? null
        : dateString[1]
    }, () => {
    })
  }

  render() {
    const {
      name,
      email,
      password,
      createAndContinue,
      options,
      role,
      showUserDates,
      initDate,
      dueDate,
    } = this.state
    const {
      userAddIsFetching,
      newColor,
      userExistsIsFetching,
      userExists,
      userExistsProfile,
      userExistsWorkclientAlreadyDone,
      intl
    } = this.props
    const isValid = (userExists === 'UserNotFound') || (userExists === 'UserAlreadyExist' && userExistsProfile !== 'admin' && !userExistsWorkclientAlreadyDone)


    return (
      <Form>
        <Form.Item>
          <RequiredField name="Email" />
          {userExistsIsFetching && <Icon type="loading" />}
          <Input name="email" value={email} placeholder="Email" onChange={this.handleInputOnChange} onBlur={this.handleEmailExists} onKeyDown={this.handleKeyPress} />
          {userExists === 'UserAlreadyExist' && userExistsProfile === 'admin' && <Alert message={intl.formatMessage({ id: 'existing_admin_mail' })} type="error" showIcon />}
          {userExists === 'UserAlreadyExist' && userExistsProfile !== 'admin' && userExistsWorkclientAlreadyDone && <Alert message={intl.formatMessage({ id: 'existing_associated_mail' })} type="error" showIcon />}
          {userExists === 'UserAlreadyExist' && userExistsProfile !== 'admin' && !userExistsWorkclientAlreadyDone && <Alert message={intl.formatMessage({ id: 'existing_not_associated_mail' })} type="warning" showIcon />}
          {userExists === 'UserNotFound' && <Alert message={intl.formatMessage({ id: 'enabled_mail' })} type="success" showIcon />}
        </Form.Item>
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: 'role' })} />
          <Select ref={this.rolSelector} defaultValue={role} onChange={this.handleRolOnChange}>
            <Option value="operator">{intl.formatMessage({ id: 'operator' })}</Option>
            <Option value="clientAdmin">{intl.formatMessage({ id: 'admin' })}</Option>
            <Option value="admin">{intl.formatMessage({ id: 'super_admin' })}</Option>
          </Select>
        </Form.Item>
        {userExists === 'UserNotFound' &&
          <React.Fragment>
            <Form.Item>
              <RequiredField name={intl.formatMessage({ id: 'name' })} />
              <Input name="name" value={name} placeholder={intl.formatMessage({ id: 'name' })} onChange={this.handleInputOnChange} />
            </Form.Item>
            <Form.Item>
              <RequiredField name={intl.formatMessage({ id: 'login_password' })} />
              <Switch
                style={{ marginLeft: 10 }}
                defaultChecked
                checkedChildren='Especificar'
                unCheckedChildren='Generar'
                onClick={this.handleSwitch}
              />
              {/* <Input name="password" value={password} placeholder={intl.formatMessage({ id: 'login_password' })} onChange={this.handleInputOnChange} /> */}
              <PasswordInput
                name="password"
                type="password"
                value={password}
                visibilityToggle={true}
                placeholder={intl.formatMessage({ id: "login_password" })}
                onChange={this.handleInputOnChange} />
            </Form.Item>
          </React.Fragment>}
        {role === 'operator' && <Form.Item>
          <RequiredField name={intl.formatMessage({ id: 'groups' })} />
          <Select
            mode="multiple"
            placeholder={intl.formatMessage({ id: 'select' })}
            onChange={this.handleOnChangeGroup}
            style={{ width: '100%' }}>
            {options}
          </Select>
        </Form.Item>}
        <br />
        <Radio.Group onChange={this.handleRadioType} defaultValue={"Infinite"} size="small">
          <Radio value={"Infinite"} > {intl.formatMessage({ id: "invitation_type_user_infinite" })}
          </Radio>
          <Radio value={"Temporary"} > {intl.formatMessage({ id: "invitation_type_user_temporary" })}
          </Radio>
        </Radio.Group>
        <br />
        {showUserDates &&
          <div>
            <RangePicker
              placeholder={intl.formatMessage({ id: "copyright_date_picker" })}
              onChange={this.handleOnChangeRangePicker}
              defaultValue={[moment(initDate, 'YYYY-MM-DD'), dueDate ? moment(dueDate, 'YYYY-MM-DD') : null]}
            />
          </div>}
        <br />
        <Form.Item>
          <Button
            type="primary"
            loading={userAddIsFetching && !createAndContinue}
            disabled={!isValid}
            style={{ backgroundColor: newColor, borderColor: newColor }}
            onClick={this.handleCreateSingleUser}>{intl.formatMessage({ id: 'create' })}</Button>
          <Button
            loading={userAddIsFetching && createAndContinue}
            type="primary"
            disabled={!isValid}
            style={{ backgroundColor: newColor, borderColor: newColor, marginLeft: '5px' }}
            onClick={this.handleCreateNContinue}>{intl.formatMessage({ id: 'create_and_continue' })}</Button>
          <Button
            type="default"
            style={{ color: newColor, borderColor: newColor, marginLeft: '5px', width: '87px', justifyContent: 'center' }}
            onClick={this.handleCancel}>{intl.formatMessage({ id: 'cancel_button' })}</Button>
        </Form.Item>
        <span style={{ color: 'red' }}>(*) </span> <span>{intl.formatMessage({ id: 'required_fields' })}</span>
      </Form>
    )
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    userAddIsFetching: state.users.userAddIsFetching,
    userAddStatus: state.users.userAddStatus,
    userExistsIsFetching: state.users.userExistsIsFetching,
    userExists: state.users.userExists,
    userExistsUserId: state.users.userExistsUserId,
    userExistsProfile: state.users.userExistsProfile,
    userExistsWorkclientAlreadyDone: state.users.userExistsWorkclientAlreadyDone,
    userExistsError: state.users.userExistsError,
    group: state.group.byClientData
  }
}

const mapDispatchToProps = {
  userExistsByEmail,
  userExistsReset,
  createUser,
  getUsers,
  userAddReset
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Create)))
